import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { Button } from '@shared';
import { SpinningLoaderComponent } from '../spining-loader/spinning-loader.component';

@Component({
  selector: 'lib-table-functions-alt',
  imports: [
    Button,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgClass,
    MatMenuModule,
    SpinningLoaderComponent,
  ],
  templateUrl: './table-functions-alt.html',
  styleUrl: './table-functions-alt.css',
  providers: [provideNativeDateAdapter()],
})
export class TableFunctionsAlt {
  @Input() isDownloading: boolean = false;
  @Input() showSearch: boolean = false;
  @Input() leftSideSearch: boolean = false;
  @Input() showDownload: boolean = false;
  @Input() searchPlaceholder: string = 'Search...';
  @Input() searchInputClass: string = 'sm:w-72';
  @Input() showStatus: boolean = false;
  /** Placeholder shown on the status/category trigger before a value is selected. */
  @Input() statusLabel: string = 'Status';
  /** Placeholder shown on the date-range trigger before a range is selected. */
  @Input() rangeLabel: string = 'Date';
  /** Renders the search box and button disabled (feature not available yet). */
  @Input() searchDisabled: boolean = false;
  /** Renders the status/category dropdown disabled. */
  @Input() statusDisabled: boolean = false;
  /** Renders the download button disabled. */
  @Input() downloadDisabled: boolean = false;
  /** Tooltip shown on controls disabled through the inputs above. */
  @Input() disabledHint: string = 'Coming soon';
  @Input() showDateFilter: boolean = false;
  @Input() showRangeFilter: boolean = false;
  @Input() statusArray: { label: string; value: any }[] = [];
  @Output() dateRangeChange = new EventEmitter<{
    startDate: Date | null;
    endDate: Date | null;
  }>();
  @Output() dateChange = new EventEmitter<{
    startDate: Date | null;
  }>();
  @Output() statusChange = new EventEmitter<any>();
  @Output() search = new EventEmitter<string>();
  @Output() download = new EventEmitter<void>();

  startDate: Date | null = null;
  endDate: Date | null = null;
  searchText: string = '';
  selectedArrayValue: any = null;

  onSearch() {
    if (this.searchDisabled) return;
    this.search.emit(this.searchText);
  }

  onClear() {
    this.searchText = '';
    this.search.emit(this.searchText);
  }

  onClearDate() {
    this.startDate = null;
    this.endDate = null;
    this.showDateFilter
      ? this.dateChange.emit({ startDate: null })
      : this.dateRangeChange.emit({ startDate: null, endDate: null });
  }

  onDateChange() {
    this.dateChange.emit({
      startDate: this.startDate,
    });
  }

  onDateRangeChange() {
    if (this.startDate && this.endDate) {
      this.dateRangeChange.emit({
        startDate: this.startDate,
        endDate: this.endDate,
      });
    }
  }

  onStatusChange(value: { label: string; value: any }) {
    this.selectedArrayValue = value;
    this.statusChange.emit(this.selectedArrayValue.value);
  }

  onDownload() {
    if (this.downloadDisabled) return;
    this.download.emit();
  }
}
